import { makeVar } from '@apollo/client';

let currentUserInfo = 0;

export const userDetail = makeVar(currentUserInfo);

